module.exports = __webpack_public_path__ + "static/waterteether2-e513e43e8c74c282607bbca5ef24389f.jpeg";